import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Routes from '../../../utils/Routes';

function GetStarted() {
  const navigate = useNavigate();
  const width = window.innerWidth;
  const scale = width / 375;
  const normalizeFontSize = (size) => Math.round(size * scale);

  return (
    <Box sx={styles.container}>
      <Box sx={styles.background}>
        <Box sx={styles.body}>
          <Box sx={styles.imgContainer}>
            <img src="/assets/images/Logo.png" alt="Logo" style={styles.logo} />
            <Typography sx={{ fontSize: normalizeFontSize(22), fontWeight: 500, color: '#234000', mt: '12%' }}>
              WELCOME
            </Typography>
            <Typography sx={{ fontSize: normalizeFontSize(35), fontWeight: 700, color: '#234000', textAlign: 'center', mt: '5%' }}>
              ALL ISLAND FENCE
            </Typography>
            <Typography sx={{ fontSize: normalizeFontSize(35), fontWeight: 700, color: '#234000', textAlign: 'center' }}>
              & RAILINGS
            </Typography>
            <Typography sx={styles.description}>
              All Island Fence & Railing, the leading fence installation company
              on Long Island. With over 35 years of experience, we are proud to
              be your trusted professionals for all your fencing and outdoor
              railing needs.
            </Typography>
          </Box>
          <Box sx={styles.buttonContainer}>
            <Button variant="contained" color="primary" fullWidth onClick={() => navigate(Routes.LogIn)}>
              Get Started
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

// Styles
const styles = {
  container: {
    textAlign: 'center',
    backgroundColor: 'rgba(35, 64, 0, 1)',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  background: {
    backgroundImage: `url('/assets/images/backgound.png')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    maxWidth: '600px',
    padding: '20px',
  },
  imgContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logo: {
    width: '150px',
    height: '150px',
    objectFit: 'contain',
  },
  description: {
    fontSize: '17px',
    marginTop: '5%',
    textAlign: 'center',
    lineHeight: '25px',
    fontWeight: 400,
  },
  buttonContainer: {
    marginTop: '3%',
    marginBottom: '10%',
  },
};

export default GetStarted;
